import { default as _91id_93XYSJMbNzTGMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/attachments/[id].vue?macro=true";
import { default as indexo6FzDgZxJ9Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/blowing-machine/index.vue?macro=true";
import { default as indexGitcxodOwPMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/bottle-production/index.vue?macro=true";
import { default as indexT98dCbazgzMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/bucket-production/index.vue?macro=true";
import { default as indexe6nOAp2XU6Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/complaints/index.vue?macro=true";
import { default as indexMw3zpf1xb5Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/contractwork/index.vue?macro=true";
import { default as indexD18sgrJ46YMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/custom-steel-tanks/index.vue?macro=true";
import { default as indexjOq2DO2HEDMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/index.vue?macro=true";
import { default as indexXpFxmWUq5AMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/stainless-pressure-vessels/index.vue?macro=true";
import { default as index3v2hmXLU8IMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/water-treatment-systems/index.vue?macro=true";
import { default as indexC17Al4M3gOMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/index.vue?macro=true";
import { default as indexFDJlSVFt3eMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/legal-notice/index.vue?macro=true";
import { default as indexjPVoObiqFfMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/privacy/index.vue?macro=true";
import { default as index5LTSXTS30gMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/tenders/index.vue?macro=true";
import { default as _91id_93TC3YOdyq52Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/accesorios/[id].vue?macro=true";
import { default as index0pvICG7E7CMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/aviso-legal/index.vue?macro=true";
import { default as indexABdR66ytF2Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/botellas/index.vue?macro=true";
import { default as indexLcBihCzSSqMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/cucharas/index.vue?macro=true";
import { default as indexHRQYRi1xSjMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/datos/index.vue?macro=true";
import { default as indexTY7t25XCLnMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/index.vue?macro=true";
import { default as indexpcTNL4Utf4Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/recipientes-a-presion-inoxidables/index.vue?macro=true";
import { default as indexhXnd0z0RiBMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/sistemas-de-tratamiento-de-agua/index.vue?macro=true";
import { default as indexeIo7LJXQSbMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/tanques-personalizados/index.vue?macro=true";
import { default as indexo8edet5jOoMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/index.vue?macro=true";
import { default as indexL6VmkWOpT6Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/licitaciones/index.vue?macro=true";
import { default as indexs6QN9OiISRMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/maquinas-de-soplado-de-botellas/index.vue?macro=true";
import { default as indexUgtt9LDgheMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/quejas/index.vue?macro=true";
import { default as indexFkpenUwTvkMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/trabajo_asalariado/index.vue?macro=true";
import { default as indexB7Yij21hd3Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/adatvedelem/index.vue?macro=true";
import { default as indexYbnIam2yOoMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/bermunka/index.vue?macro=true";
import { default as index4MZzzYfTBKMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/egyedi-tartalyok/index.vue?macro=true";
import { default as indexUZfPrRMrIYMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/index.vue?macro=true";
import { default as indexqzybcZAg8vMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/savallo-nyomastarto-edeny/index.vue?macro=true";
import { default as index6CF5Ui7XXrMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/viztisztito-berendezesek/index.vue?macro=true";
import { default as index7ltHTOyv2OMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/flakonfuvo-gepgyartas/index.vue?macro=true";
import { default as indexyuG1W29LohMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/flakongyartas/index.vue?macro=true";
import { default as indexwDAFpbhkX6Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/impresszum/index.vue?macro=true";
import { default as indexl5rFN7FBs6Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/index.vue?macro=true";
import { default as indexkHfaTvYiniMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/kanalgyartas/index.vue?macro=true";
import { default as indexCZuezhpdCjMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/palyazatok/index.vue?macro=true";
import { default as indexyVwj1rMPTmMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/panaszkezeles/index.vue?macro=true";
import { default as _91id_93j1AUtwaZk0Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/szerelekek/[id].vue?macro=true";
import { default as indexjo36rRwEVNMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/index.vue?macro=true";
import { default as _91id_93Drn0LTDyjWMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/accesorii/[id].vue?macro=true";
import { default as indexFxPBZ4Pn0UMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/cupe/index.vue?macro=true";
import { default as indexQqZB6sPax2Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/datelor/index.vue?macro=true";
import { default as indexbJWh5KQ9E8Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/index.vue?macro=true";
import { default as indexi47ULyfunNMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/instalatii-de-tratare-a-apei/index.vue?macro=true";
import { default as indexZXZQk65g29Meta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/recipiente-sub-presiune-inox/index.vue?macro=true";
import { default as index3OK0s070fYMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/rezervoare-personalizate/index.vue?macro=true";
import { default as indexEQk2zkOWJkMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/flacoane/index.vue?macro=true";
import { default as indexdX4whPh9XbMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/index.vue?macro=true";
import { default as index0clwyiSTKSMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/licitatii/index.vue?macro=true";
import { default as indexWkygqdJdyjMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/masini-de-suflat-flacoane/index.vue?macro=true";
import { default as indexWMWxV7q8yYMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/munca-salariata/index.vue?macro=true";
import { default as indexWoMrJMbg6DMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/nota-legala/index.vue?macro=true";
import { default as indexljCTTG3ZeuMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/plangeri/index.vue?macro=true";
import { default as index9nZiofrZaNMeta } from "/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/thanks/index.vue?macro=true";
export default [
  {
    name: "en-attachments-id",
    path: "/en/attachments/:id()",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/attachments/[id].vue").then(m => m.default || m)
  },
  {
    name: "en-blowing-machine",
    path: "/en/blowing-machine",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/blowing-machine/index.vue").then(m => m.default || m)
  },
  {
    name: "en-bottle-production",
    path: "/en/bottle-production",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/bottle-production/index.vue").then(m => m.default || m)
  },
  {
    name: "en-bucket-production",
    path: "/en/bucket-production",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/bucket-production/index.vue").then(m => m.default || m)
  },
  {
    name: "en-complaints",
    path: "/en/complaints",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/complaints/index.vue").then(m => m.default || m)
  },
  {
    name: "en-contractwork",
    path: "/en/contractwork",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/contractwork/index.vue").then(m => m.default || m)
  },
  {
    name: "en-custom-machinery-custom-steel-tanks",
    path: "/en/custom-machinery/custom-steel-tanks",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/custom-steel-tanks/index.vue").then(m => m.default || m)
  },
  {
    name: "en-custom-machinery",
    path: "/en/custom-machinery",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/index.vue").then(m => m.default || m)
  },
  {
    name: "en-custom-machinery-stainless-pressure-vessels",
    path: "/en/custom-machinery/stainless-pressure-vessels",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/stainless-pressure-vessels/index.vue").then(m => m.default || m)
  },
  {
    name: "en-custom-machinery-water-treatment-systems",
    path: "/en/custom-machinery/water-treatment-systems",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/custom-machinery/water-treatment-systems/index.vue").then(m => m.default || m)
  },
  {
    name: "en",
    path: "/en",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/index.vue").then(m => m.default || m)
  },
  {
    name: "en-legal-notice",
    path: "/en/legal-notice",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/legal-notice/index.vue").then(m => m.default || m)
  },
  {
    name: "en-privacy",
    path: "/en/privacy",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/privacy/index.vue").then(m => m.default || m)
  },
  {
    name: "en-tenders",
    path: "/en/tenders",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/en/tenders/index.vue").then(m => m.default || m)
  },
  {
    name: "es-accesorios-id",
    path: "/es/accesorios/:id()",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/accesorios/[id].vue").then(m => m.default || m)
  },
  {
    name: "es-aviso-legal",
    path: "/es/aviso-legal",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/aviso-legal/index.vue").then(m => m.default || m)
  },
  {
    name: "es-botellas",
    path: "/es/botellas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/botellas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-cucharas",
    path: "/es/cucharas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/cucharas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-datos",
    path: "/es/datos",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/datos/index.vue").then(m => m.default || m)
  },
  {
    name: "es-fabricacion-de-maquinaria",
    path: "/es/fabricacion-de-maquinaria",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/index.vue").then(m => m.default || m)
  },
  {
    name: "es-fabricacion-de-maquinaria-recipientes-a-presion-inoxidables",
    path: "/es/fabricacion-de-maquinaria/recipientes-a-presion-inoxidables",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/recipientes-a-presion-inoxidables/index.vue").then(m => m.default || m)
  },
  {
    name: "es-fabricacion-de-maquinaria-sistemas-de-tratamiento-de-agua",
    path: "/es/fabricacion-de-maquinaria/sistemas-de-tratamiento-de-agua",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/sistemas-de-tratamiento-de-agua/index.vue").then(m => m.default || m)
  },
  {
    name: "es-fabricacion-de-maquinaria-tanques-personalizados",
    path: "/es/fabricacion-de-maquinaria/tanques-personalizados",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/fabricacion-de-maquinaria/tanques-personalizados/index.vue").then(m => m.default || m)
  },
  {
    name: "es",
    path: "/es",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/index.vue").then(m => m.default || m)
  },
  {
    name: "es-licitaciones",
    path: "/es/licitaciones",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/licitaciones/index.vue").then(m => m.default || m)
  },
  {
    name: "es-maquinas-de-soplado-de-botellas",
    path: "/es/maquinas-de-soplado-de-botellas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/maquinas-de-soplado-de-botellas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-quejas",
    path: "/es/quejas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/quejas/index.vue").then(m => m.default || m)
  },
  {
    name: "es-trabajo_asalariado",
    path: "/es/trabajo_asalariado",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/es/trabajo_asalariado/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-adatvedelem",
    path: "/hu/adatvedelem",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/adatvedelem/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-bermunka",
    path: "/hu/bermunka",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/bermunka/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-egyedi-gepgyartas-egyedi-tartalyok",
    path: "/hu/egyedi-gepgyartas/egyedi-tartalyok",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/egyedi-tartalyok/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-egyedi-gepgyartas",
    path: "/hu/egyedi-gepgyartas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-egyedi-gepgyartas-savallo-nyomastarto-edeny",
    path: "/hu/egyedi-gepgyartas/savallo-nyomastarto-edeny",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/savallo-nyomastarto-edeny/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-egyedi-gepgyartas-viztisztito-berendezesek",
    path: "/hu/egyedi-gepgyartas/viztisztito-berendezesek",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/egyedi-gepgyartas/viztisztito-berendezesek/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-flakonfuvo-gepgyartas",
    path: "/hu/flakonfuvo-gepgyartas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/flakonfuvo-gepgyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-flakongyartas",
    path: "/hu/flakongyartas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/flakongyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-impresszum",
    path: "/hu/impresszum",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/impresszum/index.vue").then(m => m.default || m)
  },
  {
    name: "hu",
    path: "/hu",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-kanalgyartas",
    path: "/hu/kanalgyartas",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/kanalgyartas/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-palyazatok",
    path: "/hu/palyazatok",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/palyazatok/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-panaszkezeles",
    path: "/hu/panaszkezeles",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/panaszkezeles/index.vue").then(m => m.default || m)
  },
  {
    name: "hu-szerelekek-id",
    path: "/hu/szerelekek/:id()",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/hu/szerelekek/[id].vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-accesorii-id",
    path: "/ro/accesorii/:id()",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/accesorii/[id].vue").then(m => m.default || m)
  },
  {
    name: "ro-cupe",
    path: "/ro/cupe",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/cupe/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-datelor",
    path: "/ro/datelor",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/datelor/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-fabricatie-utilaje-personalizate",
    path: "/ro/fabricatie-utilaje-personalizate",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-fabricatie-utilaje-personalizate-instalatii-de-tratare-a-apei",
    path: "/ro/fabricatie-utilaje-personalizate/instalatii-de-tratare-a-apei",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/instalatii-de-tratare-a-apei/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-fabricatie-utilaje-personalizate-recipiente-sub-presiune-inox",
    path: "/ro/fabricatie-utilaje-personalizate/recipiente-sub-presiune-inox",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/recipiente-sub-presiune-inox/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-fabricatie-utilaje-personalizate-rezervoare-personalizate",
    path: "/ro/fabricatie-utilaje-personalizate/rezervoare-personalizate",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/fabricatie-utilaje-personalizate/rezervoare-personalizate/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-flacoane",
    path: "/ro/flacoane",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/flacoane/index.vue").then(m => m.default || m)
  },
  {
    name: "ro",
    path: "/ro",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-licitatii",
    path: "/ro/licitatii",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/licitatii/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-masini-de-suflat-flacoane",
    path: "/ro/masini-de-suflat-flacoane",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/masini-de-suflat-flacoane/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-munca-salariata",
    path: "/ro/munca-salariata",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/munca-salariata/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-nota-legala",
    path: "/ro/nota-legala",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/nota-legala/index.vue").then(m => m.default || m)
  },
  {
    name: "ro-plangeri",
    path: "/ro/plangeri",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/ro/plangeri/index.vue").then(m => m.default || m)
  },
  {
    name: "thanks",
    path: "/thanks",
    component: () => import("/Users/zoltangyurasz/Project/POLIOL/POLIOL_HONLAP/pages/thanks/index.vue").then(m => m.default || m)
  }
]